import type { ButtonProps as AriaButtonProps } from "react-aria-components";
import Button from "@components/AccessibleComponents/Button";

export type SubscribeProps = AriaButtonProps & {
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function Subscribe(props: SubscribeProps): React.ReactElement {
  const { setIsModalOpen } = props;

  const handleClick = () => {
    if (typeof setIsModalOpen === "undefined") return;

    setIsModalOpen(false);
  };

  return (
    <Button
      {...props}
      onPress={handleClick}
      className="w-full rounded-full bg-orange-300 px-9 py-3 font-poppins text-base font-semibold text-white outline-none"
    >
      SUBSCRIBE
    </Button>
  );
}
